export default {"src":"/_next/static/media/verify-space.f1bbe50c.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};